// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectUserGroup extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_USER_GROUP);
        this.superGroupId = null;
        this.groupId = null;
        this.groupName = null;
        this.getId = () => {
            var _a;
            return ((_a = this.groupId) === null || _a === void 0 ? void 0 : _a.toString()) || '';
        };
        this.getName = () => {
            return this.groupName || '';
        };
    }
    get GroupName() {
        return this.groupName;
    }
    set GroupName(value) {
        this.groupName = value;
    }
    get GroupId() {
        return this.groupId;
    }
    set GroupId(value) {
        this.groupId = value;
    }
    get SuperGroupId() {
        return this.superGroupId;
    }
    set SuperGroupId(value) {
        this.superGroupId = value;
    }
}
